import {Component} from "@angular/core";
import {contextPath} from "site";

@Component({
	selector: "not-found",
	template: `
		<div>
			<h1>Page not found</h1>
			<div>
				What can I do from here?
			</div>
			<div>
				<ul>
					<li><a href="{{contextPath}}/">Go to the home page</a></li>
					<li>Click on one of the tabs above</li>
					<li>Contact <a href="{{contextPath}}/support/">customer support</a></li>
				</ul>
			</div>
		</div>
	`,
})

export class NotFoundComponent {
	contextPath = contextPath;
}
